// import { useState } from 'react';
// import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
// import { ChevronDownIcon } from '@heroicons/react/20/solid';
// import { Link } from 'react-router-dom';

// // Add your product images - replace these with your actual image imports
// // import defaultProductImage from '/product/aop.png';
// import aopImage from '../assests/home/aop.png';
// import vapImage from '../assests/home/aop.png';
// import gapImage from '../assests/home/aop.png';
// // import ucmImage from '../assests/home/ultrasorb.png';
// // import odorNoxImage from '../assests/home/aop.png';
// // import ccuImage from '../assests/home/aop.png';
// import smokeNoxImage from '../assests/home/aop.png';
// import cbrImage from '../assests/home/cbr.png';
// import espImage from '../assests/home/aop.png';
// import fcapImage from '../assests/home/aop.png';
// import fsapImage from '../assests/home/aop.png';

// const products = [
//   {
//     name: "Microbial Contamination",
//     list: ['Advanced Oxidation Plasma (AOP)'],
//     links: ['/aop'],
//     images: ['/product/aop.png'],
//     description: "",
//   },
//   {
//     name: "Wall Hung Air Purifiers",
//     list: ['Virusheild Air Purifier', 'germiNOX'],
//     links: ['/vap', '/gap'],
//     images: ['/product/virshulfield.png', '/product/germinox.png'],
//     description: "",
//   },
//   {
//     name: "For Gaseous Contamination",
//     list: ['ultraSORB® Chemical Media', 'OdorNOX', 'Corrosion Control Unit', 'smokeNOX Unit'],
//     links: ['/ucm', '/OdorNOX', '/ccu', '/forminox'],
//     images: ['/product/ultrasorb.png', '/product/odorNOX.png', 'product/corrsion.png', 'product/Group 258.png'],
//     description: "",
//   },
//   {
//     name: "Particulate Contamination",
//     list: ['CBR Filter', 'ESP Filter'],
//     links: ['/cf', '/ef'],
//     images: ['/product/CBR.png', '/product/ESP.png'],
//     description: "",
//   },
//   {
//     name: "AC Filters", // Changed name to differentiate from previous category
//     list: ['Falcon C (For Cassette AC)', 'Flacon S (For Split AC)'],
//     links: ['/fcap', '/fsap'],
//     images: ['/product/FALCONC.png', '/product/FALCONS.png'],
//     description: "",
//   },
// ];

// const ProductPopover = ({ activePopover, handlePopoverToggle, handleLinkClick }) => {
//   const [hoveredImage, setHoveredImage] = useState('/product/aop.png');

//   const handleProductHover = (image) => {
//     setHoveredImage(image);
//   };

//   const handleProductLeave = () => {
//     setHoveredImage('/product/aop.png');
//   };

//   return (
//     <Popover>
//       <PopoverButton
//         className="flex items-center gap-x-1 text-md font-medium leading-6 text-[#989898] relative"
//         onClick={() => handlePopoverToggle('products')}
//       >
//         Product Range
//         <ChevronDownIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
//       </PopoverButton>

//       <Transition
//         show={activePopover === 'products'}
//         enter="transition ease-out duration-200"
//         enterFrom="opacity-0 translate-y-1"
//         enterTo="opacity-100 translate-y-0"
//         leave="transition ease-in duration-150"
//         leaveFrom="opacity-100 translate-y-0"
//         leaveTo="opacity-0 translate-y-1"
//       >
//         <PopoverPanel className="absolute left-[50%] z-10 mt-3 flex w-screen max-w-max -translate-x-1/2 px-4 header_container">
//           <div className="w-full flex overflow-hidden bg-white text-md leading-6 shadow-lg ring-1 ring-gray-900/5">
//             <div className="w-60% p-2 m-2">
//               <div className="p-4">
//                 <div className="grid grid-cols-2 gap-4">
//                   {products.map((item, productIndex) => (
//                     <div
//                       key={item.name}
//                       className="group relative flex items-start gap-x-6 rounded-lg p-4 text-md leading-6 hover:bg-gray-50 color-blue"
//                     >
//                       <div className="flex-auto">
//                         <h5 className="block font-semibold text-gray-900">{item.name}</h5>
//                         <ul className="mt-1 text-gray-600 list-inside">
//                           {item.list.map((listItem, index) => (
//                             <li key={index} className='min-w-full'>
//                               <Link
//                                 to={item.links[index]}
//                                 className="hover:text-textBlue transition-colors duration-200 w-full flex"
//                                 onClick={handleLinkClick}
//                                 onMouseEnter={() => handleProductHover(item.images[index] || '/product/aop.png')}
//                                 onMouseLeave={handleProductLeave}
//                               >
//                                 {listItem}
//                               </Link>
//                             </li>
//                           ))}
//                         </ul>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div className="divide-gray-900/5 w-1/2 ml-10">
//                 <Link
//                   to="/contact"
//                   className="text-md font-semibold text-gray-900 hover:bg-gray-100 transition-colors duration-200"
//                   onClick={handleLinkClick}
//                 >
//                   We Manufacture Customized Standalone
//                   Air Purification Equipment's
//                 </Link>
//               </div>
//             </div>

//             <div className="w-40% pl-5 m-auto">
//               <div className="cols-1 p-5 m-auto">
//                 <img 
//                   src={hoveredImage} 
//                   alt="Product" 
//                   className="w-full transition-all duration-300 ease-in-out transform hover:scale-105" 
//                 />
//               </div>
//             </div>
//           </div>
//         </PopoverPanel>
//       </Transition>
//     </Popover>
//   );
// };

// export default ProductPopover;



import { useState } from 'react';
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';

const products = [
  {
    category: "Residential & Commercial Air Purification",
    subcategories: [
      {
        name: "AOP Induct Air Purifier",
        items: [
          { name: "Pentagon AOP", link: "/aop" }
        ]
      },
      {
        name: "AOP Wall-hung Purifier",
        items: [
          { name: "Virushield AOP", link: "/vap" },
          { name: "germiNOX", link: "/gap" },
          { name: "Hygiene & Odor Control Purifier", link: "/hygiene" }
        ]
      },
      {
        name: "AOP AC Air Purifier",
        items: [
          { name: "Falcon S", link: "/fsap" },
          { name: "Falcon C", link: "/fcap" }
        ]
      },
      {
        name: "AOP Portable Air Purifier",
        items: [
          { name: "Table-Top Mini", link: "/portable" }
        ]
      }
    ]
  },
  {
    category: "Gases & Odor Control Systems",
    subcategories: [
      {
        name: "Sewer Gases & Odor Scrubber",
        items: [
          { name: "odorNOX", link: "/OdorNOX" }
        ]
      },
      {
        name: "Data Center Gases & Corrosion Control",
        items: [
          { name: "Air Filter Unit", link: "/ccu" },
          { name: "Fresh Air Unit", link: "/fresh-air-unit" }
        ]
      },
      {
        name: "Smoke & Odor Control",
        items: [
          { name: "smokeNOX: Ceiling-Hung", link: "/forminox" },
          { name: "smokeNOX: Standalone", link: "/forminox-standalone" }
        ]
      },
      {
        name: "Formaldehyde Scrubber",
        items: [
          { name: "formaNOX", link: "/formanox" },
          { name: "Modular Decontamination Unit", link: "/modular-decontamination" }
        ]
      },
      {
        name: "Toilet Exhaust Odor Scrubber",
        items: [
          { name: "Toilet OC Unit", link: "/toilet-oc" }
        ]
      }
    ]
  },
  {
    category: "ULTRAPURE® Filtration",
    subcategories: [
      {
        name: "ultraSORB® Chemical filtration",
        items: [
          { name: "gridmatriX® Filter", link: "/gridmatrix" },
          { name: "V-Cassette Filter", link: "/v-cassette" },
          { name: "ultraSORB® Media", link: "/ucm" }
        ]
      },
      {
        name: "Electrically Enhanced Filtration",
        items: [
          { name: "Electrostatic Precipitator Filter", link: "/ef" },
          { name: "Self-Charge Filter", link: "/self-charge" },
          { name: "plasmOX® ION Filter", link: "/plasmox" },
          { name: "Micro-Jet Needle ION Filter", link: "/micro-jet" },
          { name: "chargeMAX™ Polar Filter", link: "/chargemax" }
        ]
      },
      {
        name: "Advanced CBRN Filtration",
        items: [
          { name: "CBR Filter", link: "/cf" },
          { name: "Micro-Jet Needle ION CBR Filter", link: "/cbr-ion" }
        ]
      }
    ]
  }
];

const ProductPopover = ({ activePopover, handlePopoverToggle, handleLinkClick }) => {
  return (
    <Popover>
      <PopoverButton
        className="flex items-center gap-x-1 text-md font-medium leading-6 text-[#989898] relative"
        onClick={() => handlePopoverToggle('products')}
      >
        Product Range
        <ChevronDownIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
      </PopoverButton>

      <Transition
        show={activePopover === 'products'}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <PopoverPanel className="absolute left-[50%] z-10 mt-3 flex w-screen max-w-7xl -translate-x-1/2 px-4">
          <div className="w-full overflow-hidden bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5 rounded-lg">
            <div className="p-6">
              <div className="grid grid-cols-3 gap-6">
                {products.map((category, categoryIndex) => (
                  <div key={categoryIndex} className="space-y-4">
                    {/* Category Header */}
                    <div className=" bg-[#1C97D4] text-white px-4 py-3 rounded-lg">
                      <h3 className="font-bold text-base">{category.category}</h3>
                    </div>

                    {/* Subcategories */}
                    <div className="space-y-3">
                      {category.subcategories.map((subcategory, subIndex) => (
                        <div key={subIndex} className="border border-gray-200 rounded-lg overflow-hidden">
                          {/* Subcategory Header */}
                          <div className="bg-[#90C03E] text-white px-3 py-2">
                            <h4 className="font-semibold text-sm">{subcategory.name}</h4>
                          </div>

                          {/* Products List */}
                          <div className="bg-white border-t border-gray-200">
                            <ul className="divide-y divide-gray-100">
                              {subcategory.items.map((item, itemIndex) => (
                                <li key={itemIndex}>
                                  <Link
                                    to={item.link}
                                    className="block px-3 py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 transition-colors duration-200"
                                    onClick={handleLinkClick}
                                  >
                                    • {item.name}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              {/* Bottom CTA */}
              <div className="mt-6 pt-6 border-t border-gray-200">
                <Link
                  to="/contact"
                  className="block text-center text-base font-semibold text-gray-900 hover:text-blue-600 transition-colors duration-200"
                  onClick={handleLinkClick}
                >
                  We Manufacture Customized Standalone Air Purification Equipment's
                </Link>
              </div>
            </div>
          </div>
        </PopoverPanel>
      </Transition>
    </Popover>
  );
};

export default ProductPopover;







// import { useState } from 'react';
// import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
// import { ChevronDownIcon } from '@heroicons/react/20/solid';
// import { Link } from 'react-router-dom';
// import { ChevronDown, ChevronRight } from 'lucide-react'
// const products = [
//   {
//     category: "Residential & Commercial Air Purification",
//     subcategories: [
//       {
//         name: "AOP Induct Air Purifier",
//         items: [
//           { name: "Pentagon AOP", link: "/aop" }
//         ]
//       },
//       {
//         name: "AOP Wall-hung Purifier",
//         items: [
//           { name: "Virushield AOP", link: "/vap" },
//           { name: "germiNOX", link: "/gap" },
//           { name: "Hygiene & Odor Control Purifier", link: "/hygiene" }
//         ]
//       },
//       {
//         name: "AOP AC Air Purifier",
//         items: [
//           { name: "Falcon S", link: "/fsap" },
//           { name: "Falcon C", link: "/fcap" }
//         ]
//       },
//       {
//         name: "AOP Portable Air Purifier",
//         items: [
//           { name: "Table-Top Mini", link: "/portable" }
//         ]
//       }
//     ]
//   },
//   {
//     category: "Gases & Odor Control Systems",
//     subcategories: [
//       {
//         name: "Sewer Gases & Odor Scrubber",
//         items: [
//           { name: "odorNOX", link: "/OdorNOX" }
//         ]
//       },
//       {
//         name: "Data Center Gases & Corrosion Control",
//         items: [
//           { name: "Air Filter Unit", link: "/air-filter-unit" },
//           { name: "Fresh Air Unit", link: "/fresh-air-unit" }
//         ]
//       },
//       {
//         name: "Smoke & Odor Control",
//         items: [
//           { name: "smokeNOX: Ceiling-Hung", link: "/forminox" },
//           { name: "smokeNOX: Standalone", link: "/forminox-standalone" }
//         ]
//       },
//       {
//         name: "Formaldehyde Scrubber",
//         items: [
//           { name: "formaNOX", link: "/formanox" },
//           { name: "Modular Decontamination Unit", link: "/modular-decontamination" }
//         ]
//       },
//       {
//         name: "Toilet Exhaust Odor Scrubber",
//         items: [
//           { name: "Toilet OC Unit", link: "/toilet-oc" }
//         ]
//       }
//     ]
//   },
//   {
//     category: "ULTRAPURE® Filtration",
//     subcategories: [
//       {
//         name: "ultraSORB® Chemical filtration",
//         items: [
//           { name: "gridmatriX® Filter", link: "/gridmatrix" },
//           { name: "V-Cassette Filter", link: "/v-cassette" },
//           { name: "ultraSORB® Media", link: "/ucm" }
//         ]
//       },
//       {
//         name: "Electrically Enhanced Filtration",
//         items: [
//           { name: "Electrostatic Precipitator Filter", link: "/ef" },
//           { name: "Self-Charge Filter", link: "/self-charge" },
//           { name: "plasmOX® ION Filter", link: "/plasmox" },
//           { name: "Micro-Jet Needle ION Filter", link: "/micro-jet" },
//           { name: "chargeMAX™ Polar Filter", link: "/chargemax" }
//         ]
//       },
//       {
//         name: "Advanced CBRN Filtration",
//         items: [
//           { name: "CBR Filter", link: "/cf" },
//           { name: "Micro-Jet Needle ION CBR Filter", link: "/cbr-ion" }
//         ]
//       }
//     ]
//   }
// ];
// const link = ({ to, children, onClick, className }) => (
//   <a href={to} onClick={onClick} className={className}>{children}</a>
// );
// const ProductPopover = ({ activePopover, handlePopoverToggle, handleLinkClick }) => {
//   const [openSubcategories, setOpenSubcategories] = useState({});

//   const toggleSubcategory = (categoryIndex, subcategoryIndex) => {
//     const key = `${categoryIndex}-${subcategoryIndex}`;
//     setOpenSubcategories(prev => ({
//       ...prev,
//       [key]: !prev[key]
//     }));
//   };

//   const isOpen = (categoryIndex, subcategoryIndex) => {
//     const key = `${categoryIndex}-${subcategoryIndex}`;
//     return openSubcategories[key] || false;
//   };

//   return (
//     <Popover>
//       <PopoverButton
//         className="flex items-center gap-x-1 text-md font-medium leading-6 text-[#989898] relative"
//         onClick={() => handlePopoverToggle('products')}
//       >
//         Product Range
//         <ChevronDownIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
//       </PopoverButton>

//       <Transition
//         show={activePopover === 'products'}
//         enter="transition ease-out duration-200"
//         enterFrom="opacity-0 translate-y-1"
//         enterTo="opacity-100 translate-y-0"
//         leave="transition ease-in duration-150"
//         leaveFrom="opacity-100 translate-y-0"
//         leaveTo="opacity-0 translate-y-1"
//       >
//         <PopoverPanel className="absolute left-[50%] z-10 mt-3 flex w-screen max-w-7xl -translate-x-1/2 px-4">
//           <div className="w-full max-w-7xl mx-auto p-6 bg-gray-50">
//             <div className="bg-white shadow-lg rounded-lg overflow-hidden">
//               <div className="p-6">
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                   {products.map((category, categoryIndex) => (
//                     <div key={categoryIndex} className="space-y-3">
//                       {/* Category Header */}
//                       <div className="bg-gradient-to-r from-green-400 to-green-500 text-white px-4 py-3 rounded-lg shadow-md">
//                         <h3 className="font-bold text-base">{category.category}</h3>
//                       </div>

//                       {/* Subcategories Accordion */}
//                       <div className="space-y-2">
//                         {category.subcategories.map((subcategory, subIndex) => (
//                           <div key={subIndex} className="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow">
//                             {/* Accordion Header */}
//                             <button
//                               onClick={() => toggleSubcategory(categoryIndex, subIndex)}
//                               className="w-full bg-teal-700 hover:bg-teal-800 text-white px-3 py-2.5 flex items-center justify-between transition-colors"
//                             >
//                               <h4 className="font-semibold text-sm text-left">{subcategory.name}</h4>
//                               {isOpen(categoryIndex, subIndex) ? (
//                                 <ChevronDown className="w-4 h-4 flex-shrink-0" />
//                               ) : (
//                                 <ChevronRight className="w-4 h-4 flex-shrink-0" />
//                               )}
//                             </button>

//                             {/* Accordion Content */}
//                             <div
//                               className={`transition-all duration-300 ease-in-out ${isOpen(categoryIndex, subIndex)
//                                 ? 'max-h-96 opacity-100'
//                                 : 'max-h-0 opacity-0 overflow-hidden'
//                                 }`}
//                             >
//                               <ul className="divide-y divide-gray-100 bg-gray-50">
//                                 {subcategory.items.map((item, itemIndex) => (
//                                   <li key={itemIndex}>
//                                     <Link
//                                       to={item.link}
//                                       className="block px-4 py-2.5 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200 text-sm"
//                                       onClick={() => console.log('Link clicked')}
//                                     >
//                                       <span className="flex items-center">
//                                         <span className="w-1.5 h-1.5 bg-teal-600 rounded-full mr-2"></span>
//                                         {item.name}
//                                       </span>
//                                     </Link>
//                                   </li>
//                                 ))}
//                               </ul>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//                 {/* Bottom CTA */}
//                 <div className="mt-8 pt-6 border-t-2 border-gray-200">
//                   <Link
//                     to="/contact"
//                     className="block text-center text-base font-semibold text-gray-800 hover:text-blue-600 transition-colors duration-200 bg-blue-50 hover:bg-blue-100 px-6 py-3 rounded-lg"
//                     onClick={() => console.log('Contact clicked')}
//                   >
//                     We Manufacture Customized Standalone Air Purification Equipment's
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </PopoverPanel>
//       </Transition>
//     </Popover>
//   );
// };

// export default ProductPopover;


